import script from "./InvoiceFormOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceFormOption.vue?vue&type=script&lang=ts&setup=true"

import "./InvoiceFormOption.vue?vue&type=style&index=0&id=e6f92c94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6f92c94"]])

export default __exports__